<template>
	<div class="home">
		<Encabezado></Encabezado>

		<div id="content" class="snap-content bg-home">
			<div class="container">
				<div class="header-clear"></div>
				<div class="itemList-header">
					<h1>Documentos Personales</h1> 
				</div>
				<div class="container-folderlist">
					<div id="documentItemList">
						<ul class="folder-brows">
							<li class="breadcrumb1">
								<router-link to="/documentos-personales">
									<font-awesome-icon icon="fa-solid fa-folder-open" /> {{ identificador }}
								</router-link>
							</li>
							<li class="breadcrumb1" v-for="link in links">
								<router-link :to="'documentos-personales?ruta=' + link.ruta">
									{{ link.nombre }}
								</router-link>
							</li>
						</ul>
						<div class="documentList-content">
							<div>
								<div v-if="!ficherosIconos.length" class="row">
									<router-link 
									v-for="carpeta in carpetasIconos" 
									v-bind:key="carpeta.ruta"
									v-bind:data="carpeta"
									:to="'/documentos-personales?ruta=' + carpeta.ruta.replace(identificador + '/', '')" 
									class="col-lg-3 col-md-4 col-xs-6 lnkFolerFile"
									>
										<div class="docItem generaldocuments-icon-bg">
											<div class="thumbnail img-thumbnail icon-respon">
												<div v-if="carpeta.numero != '0'" class="daynum">
													<span> {{ carpeta.numero }} </span>
												</div>
												<img src="../assets/iconos/folder.png" alt="" />
												<div class="caption">
													<p>{{ carpeta.nombre }}</p>
													<p>&nbsp;</p>
												</div>
											</div>
										</div>
									</router-link>
									
								</div>

								<div v-if="ficherosIconos.length" class="row">
									<a
									v-for="fichero in ficherosIconos" 
									v-bind:key="fichero.ruta"
									v-bind:data="fichero"
									href="javascript:void(0);"
									@click="descargarFichero(fichero.ruta)"
									class="col-lg-3 col-md-4 col-xs-6 lnkFolerFile"
									>
										<div class="docItem generaldocuments-icon-bg">
											<div class="thumbnail img-thumbnail icon-respon">
												<img src="../assets/iconos/default.png" alt="">
												<div class="caption">
													<p>{{ fichero.nombre }}</p>
													<p>&nbsp;</p>
												</div>
											</div>
										</div>
									</a>
								</div>
								<hr />
								<div class="itemList-footer">
									<div class="pagination text-center"></div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<Footer></Footer>
		</div>
	</div>
</template>

<script>
// @ is an alias to /src
import Encabezado from "@/components/Encabezado.vue";
import Footer from "@/components/Footer.vue";

export default {
	name: "DocumentosPersonales",
	components: {
		Encabezado,
		Footer,
	},
	data() {
		return {
			ruta: null,
			carpetaActual: null
		};
	},
	mounted() {
		document.body.classList.remove("bg-login");
		document.body.classList.remove("login-page");

		this.cargar();
	},
	watch: {
		ficherosIconos: function(nuevoArray){
			if (nuevoArray.length){
				// console.log("viendo carpeta actual", this.carpetaActual.ruta);
				this.$store.dispatch("registrarVistaFicheros", {ruta: this.carpetaActual.ruta});
			}
		}
	},
	methods: {
		cargar: function(){
			let self = this;
			self.ruta = this.$route.query.ruta || null;
			let arrayRuta = self.rutaCompleta.split('/');

			arrayRuta.forEach(function(ruta, index, array){
				if (index == 0){
					self.carpetaActual = self.documentos;	
				}
				if (index > 0){
					if (self.carpetaActual.hasOwnProperty('carpetas')){
						let carpetas = self.carpetaActual.carpetas;
						let rutaParcial = arrayRuta.filter((carpeta, indice, array) => indice < index + 1).join('/');
						
						carpetas = (Array.isArray(carpetas))? carpetas : [carpetas];
						self.carpetaActual = carpetas.find(carpeta=>carpeta.ruta == rutaParcial);
					}	
				}
			});	
		},
		descargarFichero: function(fichero){
			// console.log('descargando:', fichero);
			this.$store.dispatch("descargarDocumentoPersonal", {
				documento: fichero
			});
		}
	},
	computed:{
		documentos: function(){
			return this.$store.state.perfil.documentosPersonales;
		},
		carpetas: function(){
			const carpetas = (!!this.ruta)? this.ruta.split('/') : [];
			
			return carpetas;
		},
		links: function(){
			const links = this.carpetas.map(function(carpeta, index, array){
				return {nombre: carpeta, ruta: array.slice(0, index + 1).join('/')};
			});

			return links;
		},
		rutaCompleta: function(){
			return (this.identificador) + ((this.ruta)? '/' + this.ruta : '');
		},
		carpetasIconos: function(){
			let carpetasIconos = [];
			let rutaCompleta = this.rutaCompleta;
			//let carpetaActual = null;
			if (!!this.carpetaActual){
				if (rutaCompleta == this.carpetaActual.ruta){
					carpetasIconos = this.carpetaActual.carpetas || carpetasIconos;
					carpetasIconos = (Array.isArray(carpetasIconos))?carpetasIconos:[carpetasIconos];
					return carpetasIconos;
				}
			}
			return carpetasIconos;
		},
		ficherosIconos: function(){
			let ficherosIconos = [];

			if (!!this.carpetaActual){
				if (this.carpetaActual.hasOwnProperty('documentos')){
					ficherosIconos = this.carpetaActual.documentos;
					ficherosIconos = (Array.isArray(ficherosIconos))?ficherosIconos:[ficherosIconos];
				}
			}

			return ficherosIconos;
		},
		identificador: function(){
			return this.documentos.nombre;
		}
	},
	beforeRouteUpdate(to, from, next) {
		let self = this;
		self.ruta = to.query.ruta;
		let arrayRuta = self.rutaCompleta.split('/');
		
		arrayRuta.forEach(function(ruta, index, array){
			if (index == 0){
				self.carpetaActual = self.documentos;	
			}
			if (index > 0){
				if (self.carpetaActual.hasOwnProperty('carpetas')){
					let carpetas = self.carpetaActual.carpetas;
					let rutaParcial = arrayRuta.filter((carpeta, indice, array) => indice < index + 1).join('/');
					
					carpetas = (Array.isArray(carpetas))? carpetas : [carpetas];
					self.carpetaActual = carpetas.find(carpeta=>carpeta.ruta == rutaParcial);
				}	
			}
		});
		
		next();
	}
};
</script>

<style>
    @import "../assets/styles/home.css";
</style>
